import { functionWithFG } from '@atlaskit/platform-feature-flags-react/function-with-fg';

import {
	type UseSmartLinkCrossProductUrlWrapperArgs,
	useSmartLinkCrossProductUrlWrapper,
} from './useSmartLinkCrossProductUrlWrapper';

const identityUrlWrapper = (url: string) => url;

const useSmartLinkCrossProductUrlWrapperFallback = (
	_args: UseSmartLinkCrossProductUrlWrapperArgs,
): ((url: string) => string) => identityUrlWrapper;

export const useSmartLinkCrossProductUrlWrapperGated: typeof useSmartLinkCrossProductUrlWrapper =
	functionWithFG(
		'platform_smartlink_xpc_url_wrapping',
		useSmartLinkCrossProductUrlWrapper,
		useSmartLinkCrossProductUrlWrapperFallback,
	);
